import { useEffect, useState } from 'react';
import { useLastViewedMoStore } from '../store/lastViewedMo.store';
import type { MoTravelListItem, MoTravelListParams } from '../types/moTravel.types';

const MAX_RETURN_SEEK_PAGE_COUNT = 10;

interface UseLoadPagesUntilMoFoundParams {
  moId: number | null;
  mos: MoTravelListItem[];
  loadedPageCount: number;
  listParams: MoTravelListParams;
  canLoadMore: boolean;
  onLoadMore: () => void;
}

export function useLoadPagesUntilMoFound({
  moId,
  mos,
  loadedPageCount,
  listParams,
  canLoadMore,
  onLoadMore,
}: UseLoadPagesUntilMoFoundParams) {
  const clearReturnSeek = useLastViewedMoStore((state) => state.clearReturnSeek);
  const [paramsOnReturn] = useState(() =>
    useLastViewedMoStore.getState().isReturnSeekPending ? listParams : null,
  );
  const isMoFound = moId === null || mos.some((mo) => mo.userId === moId);
  const shouldLoadMore =
    !isMoFound &&
    canLoadMore &&
    listParams === paramsOnReturn &&
    loadedPageCount < MAX_RETURN_SEEK_PAGE_COUNT;

  useEffect(() => {
    clearReturnSeek();
  }, [clearReturnSeek]);

  useEffect(() => {
    if (shouldLoadMore) onLoadMore();
  }, [shouldLoadMore, onLoadMore]);
}
